import { Head, router } from "@inertiajs/react"

import TextLink from "@/components/text-link"
import AttributeDisplay from "@/components/ui/attribute-display"
import AttributesContainer from "@/components/ui/attributes-container"
import LogoPreview from "@/components/ui/logo-preview"
import RecordPageHeader from "@/components/ui/record-page-header"
import type { RecordPageHeaderAction } from "@/components/ui/record-page-header"
import AdminLayout from "@/layouts/admin-layout"
import {
  adminAccountPath,
  adminUserPath,
  adminUsersPath,
  editAdminUserPath,
  impersonateAdminUserPath,
} from "@/routes"
import type { BreadcrumbItem, User } from "@/types"

export default function ShowUser({ user }: { user: User }) {
  const breadcrumbs: BreadcrumbItem[] = [
    {
      title: "Users",
      href: adminUsersPath(),
    },
    {
      title: user.name,
      href: adminUserPath({ id: user.uid }),
    },
  ]

  const actions: RecordPageHeaderAction[] = [
    {
      label: "Impersonate",
      onClick: () => router.post(impersonateAdminUserPath({ id: user.uid })),
      inline: true,
    },
  ]

  return (
    <AdminLayout breadcrumbs={breadcrumbs}>
      <Head title={breadcrumbs[breadcrumbs.length - 1].title} />
      <div className="mx-auto flex h-full w-full max-w-3xl flex-col gap-6 p-4">
        <RecordPageHeader
          title={user.name}
          state={user.state}
          editPath={editAdminUserPath({ id: user.uid })}
          deletePath={adminUserPath({ id: user.uid })}
          actions={actions}
        />
        <div className="space-y-3">
          <h2 className="text-base font-semibold">Details</h2>
          <AttributesContainer className="gap-6">
            <AttributeDisplay label="Email" value={user.email} />
            <AttributeDisplay
              label="Account"
              value={
                user.account_uid ? (
                  <TextLink
                    href={adminAccountPath({ id: user.account_uid })}
                    as="div"
                    prefetch
                  >
                    {user.account?.name}
                  </TextLink>
                ) : null
              }
            />
            <AttributeDisplay
              label="Photo"
              value={
                user.avatar_url ? (
                  <LogoPreview
                    src={user.avatar_url}
                    alt={user.name}
                    className="w-16"
                  />
                ) : (
                  "—"
                )
              }
            />
          </AttributesContainer>
        </div>
      </div>
    </AdminLayout>
  )
}
